import React, { memo, useMemo } from 'react';
import { IPartner } from '../../../model/partner';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Box, Grid } from '@material-ui/core';
import TopPartner from '../../TopPartner';
import { useStyles } from './styles';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { fhwSliceActions } from '../../../store/modules/fhw/reducer';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import { partnerCategoriesSelector } from '../../../store/modules/filters/selectors';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import Button from 'global/react-mui/atoms/Button';
import { mapSliceActions } from '../../../store/modules/map/reducer';
import Certificate from '../../Certificate/Certificate';

const PartnerCardMobile: React.FC<{ partner: IPartner }> = ({ partner: { name, address, id, isCertified, isTopPartner, categories }, ...props }) => {

	const dispatch = useDispatch();
	const classes = useStyles();
	const partnerCategories = useSelector(partnerCategoriesSelector);
	const { partnerCardMobileContactForm, partnerCardMobileGetACall } = useSelector(translationsSelector);

	const openIndividualProfileDrawer = () => {
		dispatch(fhwSliceActions.setSelectedPartner(`${id}`));
		dispatch(uiSliceActions.setIsIndividualProfileDrawerOpen({ isOpen: true }));
	};

	const setCurrentPositionOnMapCenter = () => {
		dispatch(mapSliceActions.setMapCentre({ lat: address.lat, lng: address.lng }));
		dispatch(fhwSliceActions.setFocussedPartnerId(id));
		dispatch(mapSliceActions.setMapZoom(14));
	};

	const size = isCertified || isTopPartner ? 9 : 10

	return (
		<Card className={classes.root} {...props}>
			<CardContent className={classes.content} onClick={setCurrentPositionOnMapCenter}>
				<Grid container>
					<Grid item xs={size ? size : 9}>
						<Typography component="h4" variant="h4" className={classes.companyName}>
							{name}
						</Typography>
						<Typography variant="body1" color="textSecondary" className={classes.companyDetail}>
							{`${address.address1} ${address.address2}`}
						</Typography>
						<Typography variant="body1" color="textSecondary" className={classes.companyDetail}>
							{`${address.postcode} ${address.city}`}
						</Typography>
						<Box display="flex">
							{partnerCategories
								?.filter((cat) => categories?.includes(cat.value))
								?.map((category) => {
									return (
										<IconRenderer
											key={category.label}
											shape="squared"
											bgColor="#E0E0E0"
											color="#A7A7A7"
											boxProps={{ marginRight: '8px', justifyContent: 'center' }}
											icon={category?.icon}
										/>
									);
								})}
						</Box>
					</Grid>
					{(isCertified || isTopPartner) && <Grid item xs={3} className={classes.topPartner}>
						{isCertified && <span><Certificate size="small" /></span>}
						{isTopPartner && <span><TopPartner size="small" /></span>}
					</Grid>}
				</Grid>
			</CardContent>
			<Box display="flex" justifyContent="flex-end" width="100%">
				<Button onClick={openIndividualProfileDrawer} mr={2} variant="outlined" className={classes.roundedButton}>
					{partnerCardMobileContactForm}
				</Button>
				<Button href={`tel:${address.phoneNumber}`} variant="outlined" className={classes.roundedButton}>
					{partnerCardMobileGetACall}
				</Button>
			</Box>
		</Card>
	);
};

export default memo(PartnerCardMobile);
